module.exports = __webpack_public_path__ + "static/media/UNI-101-badge.f5458967.svg";